import { i18n } from '@/plugins/i18n';

export const OPEN_IBAN_VALIDATION_API_URL = 'https://openiban.com/validate';

export const IBAN_VALIDATION_DEBOUNCE_DELAY = 500;

export const PROFILE_UPDATE_DEBOUNCE_DELAY = 500;

export enum TherapistType {
  Physiotherapy = 'PHYSIOTHERAPY',
  Other = 'OTHER',
}

export const TherapistTypeLabelMap = {
  [TherapistType.Physiotherapy]: i18n.t('profile.physiotherapist'),
  [TherapistType.Other]: i18n.t('profile.alternativeTherapistType'),
}